export enum SchedulePatternType {
    interval = 'interval',
    schedule = 'pattern',
    sequence = 'cadence',
}
